export const cnmapMarketplace = "/checkout";

